import React, { useState } from "react";
import { useTheme } from "../../App";
import styles from "./Home.module.css";
import SpinningLego from "./SpinningLego";
import { analytics } from "../../firebase/config";
import HeroView from "../../components/Home/HeroView";
import modifyIconLight from "../../assets/modify_light.svg";
import modifyIconDark from "../../assets/modify_dark.svg";
import checkMessagesIconLight from "../../assets/check_messages_light.svg";
import checkMessagesIconDark from "../../assets/check_messages_dark.svg";
import thumbsUpFillIconLight from "../../assets/thumbs_up_fill_light.svg";
import thumbsUpFillIconDark from "../../assets/thumbs_up_fill_dark.svg";
import thumbsDownFillIconLight from "../../assets/thumbs_down_fill_light.svg";
import thumbsDownFillIconDark from "../../assets/thumbs_down_fill_dark.svg";
import { logEvent } from "firebase/analytics";
// Import your icons
import brandonImg from "../../assets/brandon.png";
import heroImageJpg from "../../assets/heroImage.jpg"; // Added import
import noahFooterLight from "../../assets/noah_light_footer.png";
import noahFooterDark from "../../assets/noah_dark_footer.png";
import checkActiveIconLight from "../../assets/check_active_light.svg";
import checkActiveIconDark from "../../assets/check_active_dark.svg";
import geminiIcon from "../../assets/geminiIcon.svg";
import claudeIcon from "../../assets/claudeIcon.svg";
import gptIconLight from "../../assets/gptIconLight.svg";
import gptIconDark from "../../assets/gptIconDark.svg";
import chevronActiveIconLight from "../../assets/chevron_unit_light.svg";
import chevronActiveIconDark from "../../assets/chevron_unit_dark.svg";
import loadingIconLight from "../../assets/loading_light.svg";
import loadingIconDark from "../../assets/loading_dark.svg";
import diffusionIconLight from "../../assets/diffusion_light.svg";
import diffusionIconDark from "../../assets/diffusion_dark.svg";
import smallIconLight from "../../assets/small_close_light.svg";
import smallIconDark from "../../assets/small_close_dark.svg";
import menuIconLight from "../../assets/menu_light.svg";
import menuIconDark from "../../assets/menu_dark.svg";
import closeIconLight from "../../assets/close_light.svg";
import closeIconDark from "../../assets/close_dark.svg";
import sendIconLight from "../../assets/send_dark.svg";
import sendIconDark from "../../assets/send_light.svg";
import sendIconDisabledLight from "../../assets/send_disabled_light.svg";
import sendIconDisabledDark from "../../assets/send_disabled_dark.svg";
import noCardIconLight from "../../assets/no_card_light.svg";
import noCardIconDark from "../../assets/no_card_dark.svg";
import noWorkIconLight from "../../assets/no_work_light.svg";
import noWorkIconDark from "../../assets/no_work_dark.svg";
import chatIconLight from "../../assets/chat_light.svg";
import chatIconDark from "../../assets/chat_dark.svg";
import pointIconLight from "../../assets/cursor_light.svg";
import pointIconDark from "../../assets/cursor_dark.svg";
import selectionIconLight from "../../assets/selection_active_light.svg";
import selectionIconDark from "../../assets/selection_active_dark.svg";
import treeIconLight from "../../assets/tree_light.svg";
import treeIconDark from "../../assets/tree_dark.svg";
import addIconLight from "../../assets/add_light.svg";
import addIconDark from "../../assets/add_dark.svg";
import appsIconLight from "../../assets/apps_light.svg";
import appsIconDark from "../../assets/apps_dark.svg";
import parametricIconLight from "../../assets/parametric_light.svg";
import parametricIconDark from "../../assets/parametric_dark.svg";
import chevronIconLight from "../../assets/chevron_messages_light.svg";
import chevronIconDark from "../../assets/chevron_messages_dark.svg";
import createIconLight from "../../assets/create_light.svg";
import createIconDark from "../../assets/create_dark.svg";
import renameIconLight from "../../assets/feature_light.svg";
import convoIconLight from "../../assets/modify_light.svg";
import convoIconDark from "../../assets/modify_dark.svg";
import brainIconLight from "../../assets/brain_light.svg";
import brainIconDark from "../../assets/brain_dark.svg";
import renameIconDark from "../../assets/feature_dark.svg";
import versionIconLight from "../../assets/version_light.svg";
import versionIconDark from "../../assets/version_dark.svg";
import copyMessageIconLight from "../../assets/copy_message_light.svg";
import copyMessageIconDark from "../../assets/copy_message_dark.svg";
import thumbsUpIconLight from "../../assets/thumbs_up_light.svg";
import thumbsUpIconDark from "../../assets/thumbs_up_dark.svg";
import thumbsDownIconLight from "../../assets/thumbs_down_light.svg";
import thumbsDownIconDark from "../../assets/thumbs_down_dark.svg";
import restoreIconLight from "../../assets/restore_light.svg";
import restoreIconDark from "../../assets/restore_dark.svg";
import exportIconLight from "../../assets/file_light.svg";
import exportIconDark from "../../assets/file_dark.svg";
import shareIconLight from "../../assets/share_light.svg";
import shareIconDark from "../../assets/share_dark.svg";
import privateRedIcon from "../../assets/private_red.svg";
import publicGreenIcon from "../../assets/public_green.svg";
import deviceVideoLight from "../../assets/device_light.mp4";
import deviceVideoDark from "../../assets/device_dark.mp4";
import deviceIconLight from "../../assets/device_light.svg";
import deviceIconDark from "../../assets/device_dark.svg";
import creditsIconLight from "../../assets/credits_light.svg";
import creditsIconDark from "../../assets/credits_dark.svg";
import lightIconActiveLightTheme from "../../assets/light_icon_active_light.svg";
import darkIconActiveDarkTheme from "../../assets/dark_icon_active_dark.svg";

interface HomeProps {
  onNavigateToLogin: () => void;
  onNavigateToSignUp: () => void;
}

const Home: React.FC<HomeProps> = ({
  onNavigateToLogin,
  onNavigateToSignUp,
}) => {
  const { theme, setTheme } = useTheme();
  const getActualTheme = (): "light" | "dark" => {
    if (theme === "system") {
      return window.matchMedia("(prefers-color-scheme: dark)").matches
        ? "dark"
        : "light";
    }
    return theme as "light" | "dark";
  };
  const actualTheme = getActualTheme();
  const [copiedMessage1, setCopiedMessage1] = useState(false);
  const [heroSelection, setHeroSelection] = useState<any[]>([]);
  const [heroMeasurement, setHeroMeasurement] = useState<number>(0);

  const handleClearHeroSelection = () => {
    window.dispatchEvent(new CustomEvent("clearHeroSelection"));
  };
  const [copiedMessage2, setCopiedMessage2] = useState(false);
  const [thumbsUp1, setThumbsUp1] = useState(false);
  const [thumbsDown1, setThumbsDown1] = useState(false);
  const [thumbsUp2, setThumbsUp2] = useState(false);
  const [thumbsDown2, setThumbsDown2] = useState(false);
  const [isHeroIconHovered, setIsHeroIconHovered] = useState(false);
  const [isHeroAvatarHovered, setIsHeroAvatarHovered] = useState(false);
  const [isHeroAddHovered, setIsHeroAddHovered] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  const [showFooterBorder, setShowFooterBorder] = useState(true);
  const diffusionIcon =
    actualTheme === "dark" ? diffusionIconDark : diffusionIconLight;
  const hoverDiffusionIcon =
    actualTheme === "dark" ? diffusionIconLight : diffusionIconDark;
  const menuIcon = actualTheme === "dark" ? menuIconDark : menuIconLight;
  const closeIcon = actualTheme === "dark" ? closeIconDark : closeIconLight;
  const sendIcon = actualTheme === "dark" ? sendIconDark : sendIconLight;
  const noCardIcon = actualTheme === "dark" ? noCardIconDark : noCardIconLight;
  const deviceIcon = actualTheme === "dark" ? deviceIconDark : deviceIconLight;
  const deviceVideo =
    actualTheme === "dark" ? deviceVideoDark : deviceVideoLight;
  const creditsIcon =
    actualTheme === "dark" ? creditsIconDark : creditsIconLight;
  const chevronIcon =
    actualTheme === "dark" ? chevronIconDark : chevronIconLight;

  const themeIcon =
    actualTheme === "light"
      ? lightIconActiveLightTheme
      : darkIconActiveDarkTheme;
  const noWorkIcon = actualTheme === "dark" ? noWorkIconDark : noWorkIconLight;
  const smallIcon = actualTheme === "dark" ? smallIconDark : smallIconLight;
  const convoIcon = actualTheme === "dark" ? convoIconDark : convoIconLight;
  const brainIcon = actualTheme === "dark" ? brainIconDark : brainIconLight;
  const createIcon = actualTheme === "dark" ? createIconDark : createIconLight;
  const modifyIcon = actualTheme === "dark" ? modifyIconDark : modifyIconLight;
  const copyMessageIcon =
    actualTheme === "dark" ? copyMessageIconDark : copyMessageIconLight;
  const checkMessagesIcon =
    actualTheme === "dark" ? checkMessagesIconDark : checkMessagesIconLight;
  const thumbsUpIcon =
    actualTheme === "dark" ? thumbsUpIconDark : thumbsUpIconLight;
  const thumbsUpFillIcon =
    actualTheme === "dark" ? thumbsUpFillIconDark : thumbsUpFillIconLight;
  const thumbsDownIcon =
    actualTheme === "dark" ? thumbsDownIconDark : thumbsDownIconLight;
  const thumbsDownFillIcon =
    actualTheme === "dark" ? thumbsDownFillIconDark : thumbsDownFillIconLight;
  const restoreIcon =
    actualTheme === "dark" ? restoreIconDark : restoreIconLight;
  const selectionActiveIcon =
    actualTheme === "dark" ? selectionIconDark : selectionIconLight;

  const faqs = [
    {
      question: "What is Noah?",
      answer: (
        <>
          <p>
            Noah is an AI-native conversational CAD tool. You can create and
            edit parametric 3D parts using just natural language. It's 100%
            browser-based, meaning it works seamlessly on desktop, tablet, and
            mobile with zero downloads required.
          </p>
        </>
      ),
    },
    {
      question: "Is this real CAD?",
      answer: (
        <>
          <p>
            <span className={styles.bold}>Yes.</span> Noah isn't just generating
            meshes or 3D approximations. It's built on reverse-engineered Open
            CASCADE (the same geometry kernel used by pro CAD platforms).
          </p>
          <p>
            You get true B-Rep solids, parametric feature trees, editable
            dimensions, and precise selection context.
          </p>
        </>
      ),
    },
    {
      question: "What can I build and export?",
      answer: (
        <>
          <p>
            You can build individual parts with full parametric control. Right
            now, you can export as <span className={styles.bold}>.STL</span>{" "}
            (for 3D printing) or <span className={styles.bold}>.STEP</span> (for
            CAD exchange).
          </p>
          <p>We'll be releasing additional export formats soon.</p>
        </>
      ),
    },
    {
      question: "How do generations work?",
      answer: (
        <>
          <p>One generation equals any "create" or "edit" operation.</p>
          <ul className={styles.faqList}>
            <li className={styles.faqListItem}>
              <span className={styles.bold}>Always free:</span> Deletions,
              branching, exports, and sharing don't cost generations.
            </li>
            <li className={styles.faqListItem}>
              <span className={styles.bold}>Free tier:</span> Daily generations
              reset every 24 hours and don't roll over.
            </li>
            <li className={styles.faqListItem}>
              <span className={styles.bold}>Paid tiers:</span> Monthly
              generation credits roll over indefinitely if unused.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Can I collaborate and share?",
      answer: (
        <>
          <p>
            Projects are private by default. You can share view-only links
            anytime, or branch any project to explore different design
            variations.
          </p>
          <p>Edit-enabled collaboration (multiplayer) is coming soon.</p>
        </>
      ),
    },
    {
      question: "What's on the roadmap?",
      answer: (
        <>
          <p>
            We're actively improving Noah's engineering reasoning to give you
            better suggestions and higher precision. Feature-wise, we're
            actively developing assemblies, image-to-CAD workflows,
            architectural modeling, and collaborative edit links.
          </p>
        </>
      ),
    },
  ];

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [isLogoHovered, setIsLogoHovered] = useState(false);

  const useTypingPlaceholder = (phrases: string[]) => {
    const [currentText, setCurrentText] = useState("");
    const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
    const [isTyping, setIsTyping] = useState(true);
    const [isPaused, setIsPaused] = useState(false);

    React.useEffect(() => {
      const currentPhrase = phrases[currentPhraseIndex];

      if (isPaused) {
        const pauseTimer = setTimeout(() => {
          setIsPaused(false);
          setIsTyping(false);
        }, 2000);
        return () => clearTimeout(pauseTimer);
      }

      if (isTyping) {
        if (currentText.length < currentPhrase.length) {
          const typingTimer = setTimeout(() => {
            setCurrentText(currentPhrase.slice(0, currentText.length + 1));
          }, 50);
          return () => clearTimeout(typingTimer);
        } else {
          setIsPaused(true);
        }
      } else {
        if (currentText.length > 0) {
          const deletingTimer = setTimeout(() => {
            setCurrentText(currentText.slice(0, -1));
          }, 30);
          return () => clearTimeout(deletingTimer);
        } else {
          setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
          setIsTyping(true);
        }
      }
    }, [currentText, currentPhraseIndex, isTyping, isPaused, phrases]);

    return currentText;
  };
  const [inputValue, setInputValue] = useState("");
  const [showModelMenu, setShowModelMenu] = useState(false);
  const [selectedModel, setSelectedModel] = useState("gemini-3-pro-preview");
  const [isModelButtonHovered, setIsModelButtonHovered] = useState(false);

  const modelDropdownRef = React.useRef<HTMLDivElement>(null);
  const modelButtonRef = React.useRef<HTMLButtonElement>(null);
  const inputTextareaRef = React.useRef<HTMLTextAreaElement>(null);
  const [isAnnualHobbyist, setIsAnnualHobbyist] = useState(false);
  const [isAnnualPro, setIsAnnualPro] = useState(false);
  const checkIcon =
    actualTheme === "dark" ? checkActiveIconDark : checkActiveIconLight;
  // Icons
  const gptIcon = actualTheme === "dark" ? gptIconDark : gptIconLight;
  const chevronActiveIcon =
    actualTheme === "dark" ? chevronActiveIconDark : chevronActiveIconLight;
  const loadingIcon =
    actualTheme === "dark" ? loadingIconDark : loadingIconLight;
  // Note: sendIcon and chevronIcon are already defined in your existing code
  const noahLogoDefault =
    actualTheme === "dark" ? noahFooterDark : noahFooterLight;
  const noahLogoHover =
    actualTheme === "dark" ? noahFooterLight : noahFooterDark;
  const sendIconDisabled =
    actualTheme === "dark" ? sendIconDisabledDark : sendIconDisabledLight;
  const noahFooter = actualTheme === "dark" ? noahFooterDark : noahFooterLight;
  const aiModels = [
    {
      value: "gemini-3-pro-preview",
      label: "Gemini 3 Pro",
      provider: "Latest Google model with excellent multi-modal capabilities",
      icon: <img src={geminiIcon} alt="Gemini" className={styles.modelIcon} />,
    },
    {
      value: "claude-opus-4-6",
      label: "Claude Opus 4.6",
      provider: "Most powerful Anthropic model for complex reasoning",
      icon: <img src={claudeIcon} alt="Claude" className={styles.modelIcon} />,
    },
    {
      value: "gpt-5.2",
      label: "GPT-5.2",
      provider: "Most powerful OpenAI model with adaptive reasoning",
      icon: <img src={gptIcon} alt="GPT" className={styles.modelIcon} />,
    },
  ];

  const typingPhrases = React.useMemo(
    () => [
      "Create an electronics enclosure",
      "Create a 2x2 LEGO brick",
      "Create a simple stool",
      "Create a cable organizer",
      "Create a toothbrush holder",
      "Create a door handle",
      "Create a simple joystick",
      "Create a mounting bracket",
    ],
    [],
  );

  const typingPlaceholder = useTypingPlaceholder(typingPhrases);

  React.useEffect(() => {
    const textarea = inputTextareaRef.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    const scrollHeight = textarea.scrollHeight;
    const newHeight = Math.min(Math.max(scrollHeight, 24), 320);
    textarea.style.height = `${newHeight}px`;
    textarea.style.overflowY = scrollHeight > 320 ? "auto" : "hidden";
  }, [inputValue]);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        modelDropdownRef.current &&
        !modelDropdownRef.current.contains(event.target as Node) &&
        modelButtonRef.current &&
        !modelButtonRef.current.contains(event.target as Node)
      ) {
        setShowModelMenu(false);
      }
    };
    if (showModelMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModelMenu]);

  const handleSendClick = () => {
    onNavigateToSignUp();
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendClick();
    }
  };

  const canSend = inputValue.trim().length > 0;

  const handleThemeToggle = () => {
    document.documentElement.classList.add("theme-transitioning");
    setTheme(theme === "light" ? "dark" : "light");
    setTimeout(() => {
      document.documentElement.classList.remove("theme-transitioning");
    }, 0);
  };

  // Track page view and time spent
  React.useEffect(() => {
    const startTime = Date.now();

    // Log page view
    if (analytics) {
      logEvent(analytics, "page_view", {
        page_title: "Home",
        page_location: window.location.href,
        page_path: window.location.pathname,
      });
    }

    // Track time spent on page
    return () => {
      if (analytics) {
        const timeSpent = Math.round((Date.now() - startTime) / 1000); // in seconds
        logEvent(analytics, "home_page_time_spent", {
          time_spent_seconds: timeSpent,
          time_spent_minutes: Math.round(timeSpent / 60),
        });
      }
    };
  }, []);

  // Check if scrolled to bottom for footer border
  React.useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      // If we're within 10px of the bottom, hide the border
      if (windowHeight + scrollTop >= documentHeight - 10) {
        setShowFooterBorder(false);
      } else {
        setShowFooterBorder(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    // Call once on mount to set initial state
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Listen for scroll to show/hide border
  React.useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent scrolling when menu is open
  React.useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isMenuOpen]);

  const handleCopyMessage = (messageNumber: number, text: string) => {
    navigator.clipboard.writeText(text);
    if (messageNumber === 1) {
      setCopiedMessage1(true);
      setTimeout(() => setCopiedMessage1(false), 2000);
    } else {
      setCopiedMessage2(true);
      setTimeout(() => setCopiedMessage2(false), 2000);
    }
  };

  const handleThumbsUp = (messageNumber: number) => {
    if (messageNumber === 1) {
      setThumbsUp1(!thumbsUp1);
      if (thumbsDown1) setThumbsDown1(false);
    } else {
      setThumbsUp2(!thumbsUp2);
      if (thumbsDown2) setThumbsDown2(false);
    }
  };

  const handleThumbsDown = (messageNumber: number) => {
    if (messageNumber === 1) {
      setThumbsDown1(!thumbsDown1);
      if (thumbsUp1) setThumbsUp1(false);
    } else {
      setThumbsDown2(!thumbsDown2);
      if (thumbsUp2) setThumbsUp2(false);
    }
  };

  return (
    <div className={styles.container}>
      {/* Navbar */}
      <nav
        className={`${styles.navbar} ${
          isScrolled ? styles.navbarScrolled : ""
        }`}
      >
        <div className={styles.navContent}>
          {/* Logo on the left */}
          <button
            className={styles.logoButton}
            onClick={() => window.scrollTo(0, 0)}
          >
            <img
              src={noahLogoDefault}
              alt="Logo"
              className={styles.logoImageDefault}
            />
            <img
              src={noahLogoHover}
              alt="Logo"
              className={styles.logoImageHover}
            />
            <img
              src={noahLogoDefault}
              alt=""
              className={styles.logoImageSpacer}
              aria-hidden="true"
            />
          </button>
          {/* Middle menu items - only show on desktop */}
          <div className={styles.desktopMenu}>
            {/* <a href="#features" className={styles.navLink}>
              Features
            </a> */}
            <a href="#faqs" className={styles.navLink}>
              FAQs
            </a>
            <a href="#pricing" className={styles.navLink}>
              Pricing
            </a>
            <a
              href="/guide"
              className={styles.navLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/guide");
                window.dispatchEvent(new Event("popstate"));
              }}
            >
              Blog
            </a>
          </div>

          {/* Right side buttons */}
          <div className={styles.rightButtons}>
            <div
              className={`${styles.authButtons} ${
                isMenuOpen ? styles.hiddenAuthButtons : ""
              }`}
            >
              <button
                onClick={() => {
                  if (analytics) {
                    logEvent(analytics, "login_button_clicked", {
                      source: "home_page_nav",
                      location: "navbar",
                    });
                  }
                  onNavigateToLogin();
                }}
                className={styles.loginButton}
              >
                Log in
              </button>
              <button
                onClick={() => {
                  if (analytics) {
                    logEvent(analytics, "get_started_clicked", {
                      source: "home_page_nav",
                      location: "navbar",
                    });
                  }
                  onNavigateToSignUp();
                }}
                className={styles.getStartedButton}
              >
                Get started
              </button>
            </div>

            {/* <button className={styles.menuButton} onClick={toggleMenu}>
              <img
                src={isMenuOpen ? closeIcon : menuIcon}
                alt={isMenuOpen ? "Close menu" : "Open menu"}
                className={styles.menuIcon}
              />
            </button> */}
          </div>
        </div>
      </nav>

      {/* Mobile dropdown menu */}
      {isMenuOpen && (
        <div className={styles.mobileMenuDropdown}>
          <div className={styles.mobileMenuContent}>
            <a
              href="#features"
              className={styles.mobileMenuItem}
              onClick={() => setIsMenuOpen(false)}
            >
              Features
            </a>
            <div className={styles.menuDivider}></div>
            <a
              href="#pricing"
              className={styles.mobileMenuItem}
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </a>
            <div className={styles.menuDivider}></div>
            <a
              href="#faqs"
              className={styles.mobileMenuItem}
              onClick={() => setIsMenuOpen(false)}
            >
              FAQs
            </a>
            <div className={styles.menuDivider}></div>
            <a
              href="/guide"
              className={styles.footerLink}
              onClick={(e) => {
                e.preventDefault();
                window.history.pushState({}, "", "/guide");
                window.dispatchEvent(new Event("popstate"));
              }}
            >
              Blog
            </a>
          </div>
        </div>
      )}

      {/* Rest of your page content goes here */}
      <div className={styles.pageContent}>
        {/* Hero Section */}
        <div className={styles.heroSection}>
          <h1 className={styles.heroTitle}>
            Introducing Noah, the AI CAD agent for{" "}
            <span className={styles.italics}>next-gen</span> engineers,
            designers, and makers.
          </h1>
          {/* <p className={styles.heroDescription}>
            Introducing Noah, a conversational CAD agent for reasoning-driven
            design.
          </p> */}
          {/* <div className={styles.heroButtons}>
            <div className={styles.heroButton1}>Get started</div>
            <div className={styles.heroButton2}>Learn more</div>
          </div> */}

          {/* <div className={styles.noCreditCard}>
            <img src={noCardIcon} alt="" className={styles.noCreditCardIcon} />
            No credit card required
          </div> */}
          {/* Spinning LEGO brick */}
          {/* <SpinningLego /> */}
        </div>

        <div className={styles.heroLayout}>
          <div className={styles.heroLayoutLeft}>
            <div
              className={`${styles.heroLayoutLeftIcon} ${isHeroIconHovered ? styles.heroLayoutLeftIconHovered : ""}`}
              onMouseEnter={() => setIsHeroIconHovered(true)}
              onMouseLeave={() => setIsHeroIconHovered(false)}
              onClick={onNavigateToSignUp}
            >
              <img
                src={isHeroIconHovered ? hoverDiffusionIcon : diffusionIcon}
                alt="Noah"
                className={styles.heroLayoutLeftIconImg}
              />
            </div>
            <div
              className={`${styles.heroLayoutLeftIcon} ${isHeroAddHovered ? styles.heroLayoutLeftIconHoveredSubtle : ""}`}
              onMouseEnter={() => setIsHeroAddHovered(true)}
              onMouseLeave={() => setIsHeroAddHovered(false)}
              onClick={onNavigateToSignUp}
            >
              <img
                src={actualTheme === "dark" ? addIconDark : addIconLight}
                alt="Add"
                className={styles.heroLayoutLeftIconImgSmall}
              />
            </div>
            <div className={styles.heroLayoutLeftSpacer} />
            <div
              className={`${styles.heroLayoutLeftIcon} ${isHeroAvatarHovered ? styles.heroLayoutLeftIconHoveredSubtle : ""}`}
              onMouseEnter={() => setIsHeroAvatarHovered(true)}
              onMouseLeave={() => setIsHeroAvatarHovered(false)}
              onClick={onNavigateToSignUp}
            >
              <img
                src={brandonImg}
                alt="Brandon"
                className={styles.heroLayoutAvatar}
              />
            </div>
          </div>
          <div className={styles.heroLayoutMiddle}>
            <div className={styles.heroLayoutMiddleTop}>
              <span className={styles.heroLayoutMiddleTopText}>
                Raspberry Pi Case (Bottom)
              </span>
            </div>

            <div className={styles.chatLayout}>
              {/* Message 1 */}
              <div className={styles.userMessageStandalone}>
                Create a portable Raspberry Pi case with support for a Pi Camera
                Module and space for two 18650 batteries.
              </div>

              <div className={styles.aiThinkingText}>Thought for 54s</div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>EnclosureBase</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>InnerCavity</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>FrontRoundedSlot</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>BackRoundedSlot</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>RightFaceCutouts</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>InternalShelf</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>CenterDivider</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>PCBStandoffs</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>StandoffHoles</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>MountingEars</span>
              </div>

              <div className={styles.featureRow}>
                <img
                  src={createIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>MountingHoles</span>
              </div>

              <div className={styles.aiResponseText}>
                I've created a portable Raspberry Pi enclosure. You may want to
                add fillets to the external vertical edges and mounting ears to
                improve durability and print strength.
              </div>

              <div className={styles.messageButtons}>
                <button
                  className={styles.messageButton}
                  onClick={() =>
                    handleCopyMessage(
                      1,
                      "Create a Raspberry Pi 4 bottom case with mounting ears, internal standoffs for the PCB, side cutouts for ports, and a ribbon cable slot.",
                    )
                  }
                >
                  <img
                    src={copiedMessage1 ? checkMessagesIcon : copyMessageIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={() => handleThumbsUp(1)}
                >
                  <img
                    src={thumbsUp1 ? thumbsUpFillIcon : thumbsUpIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={() => handleThumbsDown(1)}
                >
                  <img
                    src={thumbsDown1 ? thumbsDownFillIcon : thumbsDownIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={onNavigateToSignUp}
                >
                  <img
                    src={restoreIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
              </div>

              {/* Message 2 - wrapped in messageGroup */}
              <div className={styles.messageGroup}>
                <div className={styles.selectionContext}>
                  <img
                    src={selectionActiveIcon}
                    alt=""
                    className={styles.selectionContextIcon}
                  />
                  <span className={styles.selectionContextText}>8 Edges</span>
                </div>

                <div className={styles.userMessage}>
                  Fillet these edges by 1 mm
                </div>
              </div>

              <div className={styles.aiThinkingText}>Thought for 9s</div>

              <div className={styles.featureRow}>
                <img
                  src={modifyIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>Fillet001</span>
              </div>

              <div className={styles.aiResponseText}>
                Added a 1 mm fillet to the selected outer mounting ear edges.
                This will improve impact resistance and reduce sharp corners.
              </div>

              <div className={styles.messageButtons}>
                <button
                  className={styles.messageButton}
                  onClick={() =>
                    handleCopyMessage(2, "Fillet these edges by 1 mm")
                  }
                >
                  <img
                    src={copiedMessage2 ? checkMessagesIcon : copyMessageIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={() => handleThumbsUp(2)}
                >
                  <img
                    src={thumbsUp2 ? thumbsUpFillIcon : thumbsUpIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={() => handleThumbsDown(2)}
                >
                  <img
                    src={thumbsDown2 ? thumbsDownFillIcon : thumbsDownIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={onNavigateToSignUp}
                >
                  <img
                    src={restoreIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
              </div>
              <div className={styles.messageGroup}>
                <div className={styles.selectionContext}>
                  <img
                    src={selectionActiveIcon}
                    alt=""
                    className={styles.selectionContextIcon}
                  />
                  <span className={styles.selectionContextText}>4 Edges</span>
                </div>

                <div className={styles.userMessage}>
                  Apply a 5 mm fillet to these outer edges
                </div>
              </div>

              <div className={styles.aiThinkingText}>Thought for 12s</div>

              <div className={styles.featureRow}>
                <img
                  src={modifyIcon}
                  alt=""
                  className={styles.featureRowIcon}
                />
                <span className={styles.featureRowText}>Fillet002</span>
              </div>

              <div className={styles.aiResponseText}>
                Applied a 5 mm fillet to the bottom outer perimeter edges.
              </div>

              <div className={styles.messageButtons}>
                <button
                  className={styles.messageButton}
                  onClick={() =>
                    handleCopyMessage(
                      2,
                      "Apply a 5 mm fillet to these outer edges",
                    )
                  }
                >
                  <img
                    src={copiedMessage2 ? checkMessagesIcon : copyMessageIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={() => handleThumbsUp(2)}
                >
                  <img
                    src={thumbsUp2 ? thumbsUpFillIcon : thumbsUpIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={() => handleThumbsDown(2)}
                >
                  <img
                    src={thumbsDown2 ? thumbsDownFillIcon : thumbsDownIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
                <button
                  className={styles.messageButton}
                  onClick={onNavigateToSignUp}
                >
                  <img
                    src={restoreIcon}
                    alt=""
                    className={styles.messageButtonIcon}
                  />
                </button>
              </div>
            </div>
            <div className={styles.heroInputWrapper}>
              {/* --- SELECTION DISPLAY --- */}
              {heroSelection.length > 0 && (
                <div className={styles.selectionDisplay}>
                  <span className={styles.selectionDisplayText}>
                    <img
                      src={selectionActiveIcon}
                      alt="Selection"
                      className={styles.selectionDisplayIcon}
                    />
                    {(() => {
                      const edges = heroSelection.filter(
                        (s) => s.type === "edge",
                      ).length;
                      const faces = heroSelection.filter(
                        (s) => s.type === "face",
                      ).length;

                      const parts = [];
                      if (faces === 1) parts.push("1 Face");
                      else if (faces > 1) parts.push(`${faces} Faces`);

                      if (edges === 1) parts.push("1 Edge");
                      else if (edges > 1) parts.push(`${edges} Edges`);

                      let displayText = parts.join(", ");

                      if (edges > 0 && heroMeasurement > 0) {
                        displayText += ` (${heroMeasurement.toFixed(2)}mm)`;
                      }

                      return displayText;
                    })()}
                  </span>
                  <button
                    className={styles.selectionDisplayClose}
                    onClick={handleClearHeroSelection}
                  >
                    <img
                      src={closeIcon}
                      alt="Clear"
                      className={styles.selectionDisplayCloseIcon}
                    />
                  </button>
                </div>
              )}
              {/* --- END SELECTION DISPLAY --- */}

              <div className={styles.heroInputBox}>
                <textarea
                  rows={1}
                  ref={inputTextareaRef}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder="Ask Noah, @ to mention"
                  className={styles.heroInput}
                />
                <div className={styles.heroInputControls}>
                  <button
                    className={styles.heroInputButton1}
                    onClick={onNavigateToSignUp}
                  >
                    Millimeters
                    <img
                      src={chevronActiveIcon}
                      alt=""
                      className={styles.heroInputChevron}
                    />
                  </button>
                  <div className={styles.heroInputControlsRight}>
                    <button
                      className={styles.heroInputButton2}
                      onClick={onNavigateToSignUp}
                    >
                      <img
                        src={geminiIcon}
                        alt="Gemini"
                        className={styles.heroInputModelIcon}
                      />
                      Gemini 3 Pro
                      <img
                        src={chevronActiveIcon}
                        alt=""
                        className={styles.heroInputChevron}
                      />
                    </button>
                    <button
                      onClick={canSend ? handleSendClick : undefined}
                      className={`${styles.heroSendButton} ${canSend ? styles.heroSendButtonActive : ""}`}
                    >
                      <img
                        src={
                          canSend
                            ? actualTheme === "dark"
                              ? sendIconDark
                              : sendIconLight
                            : actualTheme === "dark"
                              ? sendIconDisabledDark
                              : sendIconDisabledLight
                        }
                        alt="Send"
                        className={styles.heroSendIcon}
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.heroLayoutMiddleBottom}>
              <span className={styles.heroLayoutMiddleBottomText}>
                Noah can make mistakes, so double-check it.
                {/* See{" "}
                <a
                  href="/guide"
                  className={styles.heroLayoutMiddleBottomLink}
                  onClick={(e) => {
                    e.preventDefault();
                    window.history.pushState({}, "", "/guide");
                    window.dispatchEvent(new Event("popstate"));
                  }}
                >
                  Guide
                </a> */}
              </span>
            </div>
          </div>
          <div className={styles.heroLayoutRight}>
            <HeroView
              theme={actualTheme}
              onNavigateToSignUp={onNavigateToSignUp}
              onSelectionChange={setHeroSelection}
              onMeasurementChange={setHeroMeasurement}
            />
          </div>
        </div>

        {/* <div className={styles.heroImage}>
          <img
            src={heroImageJpg}
            alt="Noah CAD Interface"
            className={styles.heroImageContent}
          />
        </div> */}

        <div id="faqs" className={styles.faqSection}>
          <div className={styles.faqGrid}>
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={styles.faqItem}
                onClick={() => toggleFaq(index)}
                style={{ cursor: "pointer" }}
              >
                <div className={styles.faqQuestion}>
                  <span
                    className={`${styles.faq} ${openFaqIndex === index ? styles.faqQuestionOpen : ""}`}
                  >
                    {faq.question}
                  </span>
                  <img
                    src={chevronIcon}
                    alt=""
                    className={`${styles.faqChevron} ${
                      openFaqIndex === index ? styles.faqChevronOpen : ""
                    }`}
                  />
                </div>
                {openFaqIndex === index && (
                  <div className={styles.faqAnswer}>{faq.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Pricing Section */}
        <div id="pricing" className={styles.pricingSection}>
          <div className={styles.pricingGrid}>
            {/* 1. Free */}
            <div className={styles.pricingCard}>
              <h3 className={styles.pricingTitle}>Free</h3>
              <p className={styles.pricingDescription}>
                Discover what Noah can do.
              </p>
              <div className={styles.pricingPriceRow}>
                <span className={styles.pricingPrice}>$0</span>
                <span className={styles.pricingSubText}>/free</span>
              </div>
              <div className={styles.togglePlaceholder} />
              <button
                onClick={onNavigateToSignUp}
                className={`${styles.pricingButton} ${styles.pricingButtonDefault}`}
              >
                Get Noah Free
              </button>
              <div className={styles.pricingFeatureList}>
                <div className={styles.pricingFeaturesLabel}>Includes:</div>
                <div className={styles.pricingFeatureItem}>
                  <img src={checkIcon} alt="" className={styles.checkIcon} />
                  <span className={styles.featureText}>
                    5 daily generations (up to 30/month)
                  </span>
                </div>
                <div className={styles.pricingFeatureItem}>
                  <img src={checkIcon} alt="" className={styles.checkIcon} />
                  <span className={styles.featureText}>
                    Unlimited .STL/.STEP downloads
                  </span>
                </div>
                <div className={styles.pricingFeatureItem}>
                  <img src={checkIcon} alt="" className={styles.checkIcon} />
                  <span className={styles.featureText}>
                    Unlimited view-only links
                  </span>
                </div>
              </div>
            </div>

            {/* 2. Hobbyist */}
            <div className={styles.pricingCard}>
              <h3 className={styles.pricingTitle}>Hobbyist</h3>
              <p className={styles.pricingDescription}>
                Ideal for students, weekend builders, and first-time creators.
              </p>
              <div className={styles.pricingPriceRow}>
                <span className={styles.pricingPrice}>
                  {isAnnualHobbyist ? "$5.99" : "$9.99"}
                </span>
                <span className={styles.pricingVat}>/month (inc. VAT)</span>
              </div>
              <div className={styles.toggleRow}>
                <div
                  className={styles.toggleContainer}
                  onClick={() => setIsAnnualHobbyist(!isAnnualHobbyist)}
                >
                  {isAnnualHobbyist && (
                    <div className={styles.toggleCircleActive} />
                  )}
                </div>
                <span className={styles.toggleLabel}>
                  {isAnnualHobbyist ? "Annual (Save 40%)" : "Annual"}
                </span>
              </div>
              <button
                onClick={onNavigateToSignUp}
                className={`${styles.pricingButton} ${styles.pricingButtonDefault}`}
              >
                Get Hobbyist
              </button>
              <div>
                <div className={styles.pricingFeaturesLabel}>
                  Everything in Free, plus:
                </div>
                <div className={styles.pricingFeatureList}>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>
                      150 monthly generations
                    </span>
                  </div>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>
                      5 daily generations (up to 150/month)
                    </span>
                  </div>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>Credit rollovers</span>
                  </div>
                </div>
              </div>
            </div>

            {/* 3. Pro */}
            <div className={styles.pricingCard2}>
              <h3 className={styles.pricingTitle}>Pro</h3>
              <p className={styles.pricingDescription}>
                For freelancers and independents delivering prototypes and
                client projects.
              </p>
              <div className={styles.pricingPriceRow}>
                <span className={styles.pricingPrice}>
                  {isAnnualPro ? "$17.99" : "$29.99"}
                </span>
                <span className={styles.pricingVat}>/month (inc. VAT)</span>
              </div>
              <div className={styles.toggleRow}>
                <div
                  className={styles.toggleContainer}
                  onClick={() => setIsAnnualPro(!isAnnualPro)}
                >
                  {isAnnualPro && <div className={styles.toggleCircleActive} />}
                </div>
                <span className={styles.toggleLabel}>
                  {isAnnualPro ? "Annual (Save 40%)" : "Annual"}
                </span>
              </div>
              <button
                onClick={onNavigateToSignUp}
                className={`${styles.pricingButton} ${styles.pricingButtonPro}`}
              >
                Get Pro
              </button>
              <div>
                <div className={styles.pricingFeaturesLabel}>
                  Everything in Hobbyist, plus:
                </div>
                <div className={styles.pricingFeatureList}>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>
                      Unlimited generations
                    </span>
                  </div>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>Priority support</span>
                  </div>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>
                      Access to new features
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* 4. Enterprise */}
            <div className={styles.pricingCard}>
              <h3 className={styles.pricingTitle}>Enterprise</h3>
              <p className={styles.pricingDescription}>
                Built for organizations running collaborative, high-volume
                workflows.
              </p>
              <div className={styles.pricingPriceRow}>
                <span className={styles.pricingPrice}>Custom</span>
                <span className={styles.pricingSubText}>/seat</span>
              </div>
              <div className={styles.togglePlaceholder} />
              <a
                href="mailto:hello@noahcad.com"
                className={`${styles.pricingButton} ${styles.pricingButtonDefault}`}
              >
                Contact us
              </a>
              <div>
                <div className={styles.pricingFeaturesLabel}>
                  Everything in Pro, plus:
                </div>
                <div className={styles.pricingFeatureList}>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>SSO Enforcement</span>
                  </div>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>
                      Centralized admin
                    </span>
                  </div>
                  <div className={styles.pricingFeatureItem}>
                    <img src={checkIcon} alt="" className={styles.checkIcon} />
                    <span className={styles.featureText}>
                      Dedicated success manager
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Final CTA Section */}
        <div className={styles.ctaSection}>
          <h2 className={styles.ctaTitle}>Build something real.</h2>
        </div>
      </div>
      {/* Footer */}
      <footer
        className={`${styles.footer} ${
          showFooterBorder ? styles.footerBordered : ""
        }`}
      >
        <div className={styles.footerContent}>
          {/* <img src={noahFooter} alt="Noah" className={styles.footerFullImage} /> */}

          {/* Footer grid with columns */}
          <div className={styles.footerGrid}>
            {/* Product */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerColumnTitle}>Product</h3>
              {/* <a href="#features" className={styles.footerLink}>
                Features
              </a> */}

              <a href="#faqs" className={styles.footerLink}>
                FAQs
              </a>
              <a href="#pricing" className={styles.footerLink}>
                Pricing
              </a>
            </div>

            {/* Company */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerColumnTitle}>Company</h3>
              <a
                href="/guide"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/guide");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Blog
              </a>
            </div>

            {/* Resources */}
            <div className={styles.footerColumn}>
              <h3 className={styles.footerColumnTitle}>Resources</h3>
              <a
                href="/guide"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/guide");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Guide
              </a>
              <a
                href="/terms"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/terms");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Terms of service
              </a>
              <a
                href="/privacy"
                className={styles.footerLink}
                onClick={(e) => {
                  e.preventDefault();
                  window.history.pushState({}, "", "/privacy");
                  window.dispatchEvent(new Event("popstate"));
                }}
              >
                Privacy policy
              </a>
            </div>
          </div>
          {/* Social icons and copyright */}
          <div className={styles.footerBottom}>
            <div className={styles.footerSocial}>
              {/* <button
                className={styles.themeButton}
                onClick={handleThemeToggle}
              >
                <img
                  src={themeIcon}
                  alt="Toggle theme"
                  className={styles.themeIcon}
                />
              </button> */}
              <a
                href="https://x.com/cadwithnoah"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://bsky.app/profile/noahcad.com"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.912.58-7.387 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z" />
                </svg>
              </a>
              <a
                href="https://www.threads.net/@cadwithnoah"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 192 192"
                  fill="currentColor"
                >
                  <path d="M141.537 88.9883C140.71 88.5919 139.87 88.2104 139.019 87.8451C137.537 60.5382 122.616 44.905 97.5619 44.745C97.4484 44.7443 97.3355 44.7443 97.222 44.7443C82.2364 44.7443 69.7731 51.1409 62.102 62.7807L75.881 72.2328C81.6116 63.5383 90.6052 61.6848 97.2286 61.6848C97.3051 61.6848 97.3819 61.6848 97.4576 61.6855C105.707 61.7381 111.932 64.1366 115.961 68.814C118.893 72.2193 120.854 76.925 121.825 82.8638C114.511 81.6207 106.601 81.2385 98.145 81.7233C74.3247 83.0954 59.0111 96.9879 60.0396 116.292C60.5615 126.084 65.4397 134.508 73.775 140.011C80.8224 144.663 89.899 146.938 99.3323 146.423C111.79 145.74 121.563 140.987 128.381 132.296C133.559 125.696 136.834 117.143 138.28 106.366C144.217 109.949 148.617 114.664 151.047 120.332C155.179 129.967 155.42 145.8 142.501 158.708C131.182 170.016 117.576 174.908 97.0135 175.059C74.2042 174.89 56.9538 167.575 45.7381 153.317C35.2355 139.966 29.8077 120.682 29.6052 96C29.8077 71.3178 35.2355 52.0336 45.7381 38.6827C56.9538 24.4249 74.2039 17.11 97.0132 16.9405C119.988 17.1113 137.539 24.4614 149.184 38.788C154.894 45.8136 159.199 54.6488 162.037 64.9503L178.184 60.6422C174.744 47.9622 169.331 37.0357 161.965 27.974C147.036 9.60668 125.202 0.195148 97.0695 0H96.9569C68.8816 0.19447 47.2921 9.6418 32.7883 28.0793C19.8819 44.4864 13.2244 67.3157 13.0007 95.9325L13 96L13.0007 96.0675C13.2244 124.684 19.8819 147.514 32.7883 163.921C47.2921 182.358 68.8816 191.806 96.9569 192H97.0695C122.03 191.827 139.624 185.292 154.118 170.811C173.081 151.866 172.51 128.119 166.26 113.541C161.776 103.087 153.227 94.5962 141.537 88.9883ZM98.4405 129.507C88.0005 130.095 77.1544 125.409 76.6196 115.372C76.2232 107.93 81.9158 99.626 99.0812 98.6368C101.047 98.5234 102.976 98.468 104.871 98.468C111.106 98.468 116.939 99.0737 122.242 100.233C120.264 124.935 108.662 128.946 98.4405 129.507Z" />
                </svg>
              </a>
              <a
                href="https://www.youtube.com/@noahcad"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </a>
              <a
                href="https://www.tiktok.com/@cadwithnoah"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
                </svg>
              </a>
              <a
                href="https://www.reddit.com/r/NoahCAD/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zm5.01 4.744c.688 0 1.25.561 1.25 1.249a1.25 1.25 0 0 1-2.498.056l-2.597-.547-.8 3.747c1.824.07 3.48.632 4.674 1.488.308-.309.73-.491 1.207-.491.968 0 1.754.786 1.754 1.754 0 .716-.435 1.333-1.01 1.614a3.111 3.111 0 0 1 .042.52c0 2.694-3.13 4.87-7.004 4.87-3.874 0-7.004-2.176-7.004-4.87 0-.183.015-.366.043-.534A1.748 1.748 0 0 1 4.028 12c0-.968.786-1.754 1.754-1.754.463 0 .898.196 1.207.49 1.207-.883 2.878-1.43 4.744-1.487l.885-4.182a.342.342 0 0 1 .14-.197.35.35 0 0 1 .238-.042l2.906.617a1.214 1.214 0 0 1 1.108-.701zM9.25 12C8.561 12 8 12.562 8 13.25c0 .687.561 1.248 1.25 1.248.687 0 1.248-.561 1.248-1.249 0-.688-.561-1.249-1.249-1.249zm5.5 0c-.687 0-1.248.561-1.248 1.25 0 .687.561 1.248 1.249 1.248.688 0 1.249-.561 1.249-1.249 0-.687-.562-1.249-1.25-1.249zm-5.466 3.99a.327.327 0 0 0-.231.094.33.33 0 0 0 0 .463c.842.842 2.484.913 2.961.913.477 0 2.105-.056 2.961-.913a.361.361 0 0 0 .029-.463.33.33 0 0 0-.464 0c-.547.533-1.684.73-2.512.73-.828 0-1.979-.196-2.512-.73a.326.326 0 0 0-.232-.095z" />
                </svg>
              </a>
              <a
                href="https://www.linkedin.com/company/noahcad"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
              <a
                href="https://www.instagram.com/cadwithnoah/?igsh=MWkwbGd2bnNmZWIzNg%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </a>
              <a
                href="https://discord.gg/mYG5ZDfmP7"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
                </svg>
              </a>
            </div>

            <div className={styles.footerCopyright}>
              <span className={styles.copyright}>©</span> Noah 2026. All rights
              reserved.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
